import moment from "moment";

export class DateUtils {
    public static dateFormat = (date: number, format: string = 'YYYY/MM/DD'): string => {
        return moment(new Date(date * 1000)).utc().format(format);
    }

    public static dateTimeFormat = (date: number, format: string = 'YYYY/MM/DD HH:mm:ss'): string => {
        return moment(new Date(date * 1000)).utc().format(format);
    }
}

